export class Colorenglon {
  constructor(
    public color: string
    ) {}
}



